import React, { useEffect, useState } from "react"
import {
  Heading,
  Avatar,
  Box,
  Center,
  Image,
  Flex,
  Text,
  Stack,
  Button,
  useColorModeValue,
  AvatarGroup,
} from '@chakra-ui/react';
import { config } from "../../config/config";
import { Link, useParams } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import { useAuth, User } from "../../context/AuthContext";
import { getUserById, getAllUser } from "../../services/user";
import { Privilege } from "../../utils";

export function Profile() {
  const { user_id } = useParams()
  const { user: useAuthUser } = useAuth()

  const [user, setUser] = useState<User>({} as User)
  const [users, setUsers] = useState<User[]>([])


  async function handleEffect() {
    if (!user_id) return

    if (user_id === useAuthUser?.id) {
      return setUser(useAuthUser)
    }

    const { data } = await getUserById(user_id)
    setUser(data)
  }
  async function handleEffect2() {
    const { data } = await getAllUser()
    setUsers(data.filter(user => user.id !== user_id))
  }
  useEffect(() => {

    handleEffect()
    handleEffect2()

  }, [user_id])
  return (
    <Center py={6} flexDirection={`column`}>
      <Box mb={5}>
        <AvatarGroup size='md' max={5}>
          {users.map(user => (
            <Link key={user.id} to={`/profile/${user.id}`}>
            <Avatar  name={user.name} src={`${config.s3bucket}/user-${user.id}`} />
            </Link>
          ))}
        </AvatarGroup>
      </Box>

      <Box
        maxW={["90%", "450px"]}
        w={'full'}
        bg={useColorModeValue('white', 'gray.800')}
        boxShadow={'2xl'}
        rounded={'md'}
        overflow={'hidden'}>
        <Image
          h={'120px'}
          w={'full'}
          bg={"gray.400"}
          src="data:image/jpeg;base64,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"
          objectFit={'cover'}
        />
        <Flex justify={'center'} mt={-12}>
          <Avatar
            size={'xl'}
            src={
              `${config.s3bucket}/user-${user_id}`
            }
            css={{
              border: '2px solid white',
            }}
          />
        </Flex>

        <Box p={6}>
          <Stack spacing={0} align={'center'} mb={5}>
            <Heading fontSize={'2xl'} fontWeight={500} fontFamily={'body'}>
              {user?.name}

            </Heading>
            <Text color={'gray.500'}>
              {Privilege(user?.privilege)}
            </Text>
          </Stack>

          <Stack direction={'row'} justify={'center'} spacing={6}>
            <Stack spacing={0} align={'center'}>
              <Text fontWeight={600}>-</Text>
              <Text fontSize={'sm'} color={'gray.500'}>
                RIA
              </Text>
            </Stack>
            <Stack spacing={0} align={'center'}>
              <Text fontWeight={600}>-</Text>
              <Text fontSize={'sm'} color={'gray.500'}>
                RVT
              </Text>
            </Stack>
          </Stack>

          <Button
            onClick={() => {
              const encode = (user?.telphone?.replaceAll(" ", "").replace("(", "").replace(")", "").replace("-", ""))
              const url = `https://api.whatsapp.com/send?phone=55${encode}&text=oi`
              window.open(url)
            }}
            w={'full'}
            mt={34}
            maxW={'md'}
            colorScheme={'whatsapp'}
            leftIcon={<FaWhatsapp />}>
            <Center>
              <Text>Enviar mensagem</Text>
            </Center>
          </Button>
        </Box>
      </Box>
    </Center>
  );
}